/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseGroupByDataWidgetConfigurationModel extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("BaseGroupByDataWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return BaseGroupByDataWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<BaseGroupByDataWidgetConfigurationModel>): BaseGroupByDataWidgetConfigurationModel {
        let obj = Object.assign(new BaseGroupByDataWidgetConfigurationModel(), model);
        BaseGroupByDataWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseGroupByDataWidgetConfigurationModel>): BaseGroupByDataWidgetConfigurationModel {
        if (!model) return null;
        return BaseGroupByDataWidgetConfigurationModel.newInstance(<BaseGroupByDataWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseGroupByDataWidgetConfigurationModel) {
        if (!obj) return;

        models.BaseGroupByDataWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseGroupByDataWidgetConfigurationModel): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseGroupByDataWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.group_by_details) {
            models.BillingGroupByDetails.fixupPrototype(this.group_by_details);
        }
        if (this.group_by_account_type) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.group_by_account_type);
        }
    }

    group_by_details: models.BillingGroupByDetails;

    /**
     * Type of Cloud Provider Account Type this applies to
     */
    group_by_account_type: models.ServiceAccountNativeDetailsBase;

    /**
     * If set, group by is based on tag status
     */
    group_by_tag_status: boolean;

    /**
     * Group by is based on Resource Tag keys
     */
    group_by_tag_keys: boolean;

    /**
     * If set, group by is based on workload type
     */
    group_by_workload_type: boolean;

}
